
import VisualizationEChart from '@/components/visualization-types/VisualizationEChart';
// import VisualizationTable from '@/components/VisualizationTable';
// import VisualizationIndicator from '@/components/VisualizationIndicator';
// import VisualizationWindRose from '@/components/VisualizationWindRose';
import moment from 'moment';
import { round } from 'lodash-es';

const AUTO_MIN = (value) => Math.floor(value.min - ((value.max - value.min) * 0.1));
const AUTO_MAX = (value) => Math.ceil(value.max + ((value.max - value.min) * 0.1));

//////////////////////////////////////////////////////////////////
////////////////////////// LINE CHART ////////////////////////////
//////////////////////////////////////////////////////////////////
const lineChart = {
  component: VisualizationEChart,
  componentName: 'visualization-e-chart',
  dataTransformer: function(dataArray) {
    return dataArray.map(dataItem => {
      return {
        ...dataItem,
        // filter out "text"-type measurements
        data: dataItem.data.filter(e => typeof e[1] !== 'string'),
      };
    });
  },
  id: `line`,
  carouselHTML: `<div style="padding: .5em; text-align: center; color: #151b1e;"><i class="fa fa-line-chart" style="font-size: 5.5em;"></i></div>`,
  name: {
    translationKey: `explore_app:visualization_types.line.name`,
    fallback: `Line Chart`,
  },
  description: {
    translationKey: `explore_app:visualization_types.line.description`,
    fallback: `Data points are connected by a continuous line.`,
  },
  hideVisualizationOptions: [
    'gauge',
    'indicator',
  ],
  canExportPNG: true,
  customOptions: {
    seriesType: 'line',
    echartsOptionsModifier: function(options, context) {
      return;
    },
    echartsSeriesModifier: function(seriesConfig, context) {
      return;
    },
  },
};


//////////////////////////////////////////////////////////////////
///////////////////////// SCATTER CHART //////////////////////////
//////////////////////////////////////////////////////////////////
const scatterChart = {
  component: VisualizationEChart,
  componentName: 'visualization-e-chart',
  dataTransformer: function(dataArray) {
    return dataArray.map(dataItem => {
      return {
        ...dataItem,
        // filter out "text"-type measurements
        data: dataItem.data.filter(e => typeof e[1] !== 'string'),
      };
    });
  },
  id: `scatter`,
  carouselHTML: `<div style="padding: .5em; text-align: center; color: #151b1e;"><svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width: 7.5em; height: 7.5em;"><path fill="currentColor" d="M496 400H48V80a16 16 0 0 0-16-16H16A16 16 0 0 0 0 80v336a32 32 0 0 0 32 32h464a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16zm-336-80a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm256-160a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm-224 0a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm192 160a32 32 0 1 0-32-32 32 32 0 0 0 32 32zm-96-64a32 32 0 1 0-32-32 32 32 0 0 0 32 32z" class=""></path></svg></div>`,
  name: {
    translationKey: `explore_app:visualization_types.scatter.name`,
    fallback: `Scatter Chart`,
  },
  description: {
    translationKey: `explore_app:visualization_types.scatter.description`,
    fallback: `Each data point is shown with a single dot.`,
  },
  hideVisualizationOptions: [
    'gauge',
    'indicator',
  ],
  canExportPNG: true,
  customOptions: {
    seriesType: 'scatter',
    echartsOptionsModifier: function(options, context) {
      return;
    },
    echartsSeriesModifier: function(seriesConfig, context) {
      return;
    },
  },
};

//////////////////////////////////////////////////////////////////
///////////////////////// VERTICAL BAR ///////////////////////////
//////////////////////////////////////////////////////////////////
const verticalBarChart = {
  component: VisualizationEChart,
  componentName: 'visualization-e-chart',
  dataTransformer: function(dataArray) {
    return dataArray.map(dataItem => {
      return {
        ...dataItem,
        // filter out "text"-type measurements
        data: dataItem.data.filter(e => typeof e[1] !== 'string'),
      };
    });
  },
  id: `vertical_bar`,
  carouselHTML: `<div style="padding: .5em; text-align: center; color: #151b1e;"><i class="fa fa-bar-chart" style="font-size: 5.5em;"></i></div>`,
  name: {
    translationKey: `explore_app:visualization_types.vertical_bar.name`,
    fallback: `Vertical Bar Chart`,
  },
  description: {
    translationKey: `explore_app:visualization_types.vertical_bar.description`,
    fallback: `Each data point is represented by a vertical bar. The height of the bar represents the value.`,
  },
  hideVisualizationOptions: [
    'gauge',
    'indicator',
  ],
  canExportPNG: true,
  customOptions: {
    seriesType: 'bar',
    echartsOptionsModifier: function(options, context) {
      return;
    },
    echartsSeriesModifier: function(seriesConfig, context) {
      return;
    },
  },
};

//////////////////////////////////////////////////////////////////
//////////////////////// HORIZONTAL BAR //////////////////////////
//////////////////////////////////////////////////////////////////
const horizontalBarChart = {
  component: VisualizationEChart,
  componentName: 'visualization-e-chart',
  dataTransformer: function(dataArray) {
    return dataArray.map(dataItem => {

      const editedMeasurementArray = dataItem.data.map(([time, value]) => {
        return [ value, time ];
      });

      return {
        ...dataItem,
        // filter out "text"-type measurements
        data: editedMeasurementArray.filter(e => typeof e[0] !== 'string'),
      };

    });
  },
  id: `horizontal_bar`,
  carouselHTML: `<div style="padding: .5em; text-align: center; color: #151b1e;"><i class="fa fa-bar-chart" style="font-size: 5.5em; transform: scale(0.75) scaleX(-1.5) rotate(270deg)"></i></div>`,
  name: {
    translationKey: `explore_app:visualization_types.horizontal_bar.name`,
    fallback: `Horizontal Bar Chart`,
  },
  description: {
    translationKey: `explore_app:visualization_types.horizontal_bar.description`,
    fallback: `Each data point is represented by a horizontal bar. The height of the bar represents the value.`,
  },
  hideVisualizationOptions: [
    'gauge',
    'indicator',
  ],
  canExportPNG: true,
  customOptions: {
    seriesType: 'bar',
    echartsOptionsModifier: function(options, context) {
      options.xAxis = [
        {
          type: 'value',
          show: context.visualizationOptions.leftAxis.show,
          min: context.visualizationOptions.leftAxis.min || AUTO_MIN,
          max: context.visualizationOptions.leftAxis.max || AUTO_MAX,
          name: context.visualizationOptions.leftAxis.label || '',
          nameLocation: context.visualizationOptions.leftAxis.alignLabel,
        },
        {
          type: 'value',
          show: context.visualizationOptions.rightAxis.show,
          min: context.visualizationOptions.rightAxis.min || AUTO_MIN,
          max: context.visualizationOptions.rightAxis.max || AUTO_MAX,
          name: context.visualizationOptions.rightAxis.label || '',
          nameLocation: context.visualizationOptions.leftAxis.alignLabel,
        },
      ];

      options.yAxis = {
        type: 'time',
        show: context.visualizationOptions.xAxis.show,
      };

      options.grid.left = 10;

      options.tooltip.formatter = function(params, ticket, callback) {
        if (!params[0]) params = [params];

        let tooltip = `${moment(params[0].value[1]).format('YYYY-MM-DD HH:mm:ss')}`;

        for (let series of params) {
          const measurementDefinition = context.formattedData.find(e => e.id === series.seriesId).measurementDefinition;
          const roundedValue = round(series.value[0], measurementDefinition.precision);
          
          let unitText = '';
          if (measurementDefinition.unit_id) {
            const unit = context.uomUnits.find(e => e.unit_id === measurementDefinition.unit_id);

            if (unit) {
              unitText = unit.symbol;
            }
          }
          
          tooltip += `<br><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${series.color};"></span>`;
          tooltip += `${series.seriesName}: ${roundedValue} ${unitText}`;
        }

        return tooltip;
      };
    },
    echartsSeriesModifier: function(seriesConfig, context) {
      delete seriesConfig.yAxisIndex;

      seriesConfig.xAxisIndex = context.seriesOptions ? (context.seriesOptions.yAxis === 'left' ? 0 : 1) : 0;
    },
  },
};

//////////////////////////////////////////////////////////////////
//////////////////////// DEPTH CHART //////////////////////////
//////////////////////////////////////////////////////////////////
const depthChart = {
  component: VisualizationEChart,
  componentName: 'visualization-e-chart',
  dataTransformer: function(dataArray, {seriesOptions, visualizationOptions, stations}) {

    const addMinMax = visualizationOptions.display.toggleChangeOverTime;
    const currentMeasurements = [];
    const minMeasurements = [];
    const maxMeasurements = [];
    const defaultStationId = dataArray[0] ? dataArray[0].stationId : undefined;

    const dataArrayInDepthOrder = dataArray.sort((a, b) => {
      const aDepth = seriesOptions[a.key].numericDepth;
      const bDepth = seriesOptions[b.key].numericDepth;
      return aDepth - bDepth;
    });

    dataArrayInDepthOrder.forEach(dataItem => {

      const sOptions = seriesOptions[dataItem.key];
      const station = stations.find(s => s.id === dataItem.stationId);
      const sensorDefinition = station.sensor_definitions.find(sDef => sDef.name === dataItem.measurementName);
      const depth = sOptions.numericDepth;

      const selectedMeasurements = dataItem.data.reduce((selected, [time, value]) => {
        if (!selected.current || selected.current[0] < time) {
          selected.current = [time, value];
        }
        if (!selected.min || selected.min[1] > value) {
          selected.min = [time, value];
        }
        if (!selected.max || selected.max[1] < value) {
          selected.max = [time, value];
        }
        return selected;
      }, {});

      // Add some additional dimensions to each datapoint for use in the tooltip.
      const extraValues = [station.name, sensorDefinition.name, sensorDefinition.precision, sensorDefinition.unit];

      if (selectedMeasurements.current) {
        currentMeasurements.push([selectedMeasurements.current[1], depth, selectedMeasurements.current[0], ...extraValues]);
      }
      if (selectedMeasurements.min) {
        minMeasurements.push([selectedMeasurements.min[1], depth, selectedMeasurements.min[0], ...extraValues]);
      }
      if (selectedMeasurements.min) {
        maxMeasurements.push([selectedMeasurements.max[1], depth, selectedMeasurements.max[0], ...extraValues]);
      }

    });
 
    const newDataArray = [
      {
        data: currentMeasurements,
        key: 'current',
        measurementName: 'current-name',
        stationId: defaultStationId,
        title: 'Current title'
      }
    ];

    if (addMinMax) {
      newDataArray.unshift({
        data: maxMeasurements,
        key: 'max',
        measurementName: 'max-name',
        stationId: defaultStationId,
        title: 'Max title'
      });
      newDataArray.unshift({
        data: minMeasurements,
        key: 'min',
        measurementName: 'min-name',
        stationId: defaultStationId,
        title: 'Min title'
      });
    }

    return newDataArray;
  },
  seriesOptionsTransformer: function(seriesOptions, {visualizationOptions}) {

    const newSeriesOptions = {
      current: {
        color: '#333333',
        label: 'Current',
        lineStyle: 'solid',
        size: 3,
        yAxis: 'left',
        showInLegend: true,
      }
    };

    if (visualizationOptions.display.toggleChangeOverTime) {
      newSeriesOptions.min = {
        color: '#1885A3',
        label: 'Min',
        lineStyle: 'dotted',
        size: 3,
        yAxis: 'left',
        showInLegend: true
      };
      newSeriesOptions.max = {
        color: '#F0613D',
        label: 'Max',
        lineStyle: 'dotted',
        size: 3,
        yAxis: 'left',
        showInLegend: true
      };

    }

    return newSeriesOptions;

  },
  id: `depth_chart`,
  carouselHTML: `<div style="padding: .5em; text-align: center; color: #151b1e;"><i class="fa fa-line-chart" style="font-size: 5.5em; transform: scaleY(-1);"></i></div>`,
  name: {
    translationKey: `explore_app:visualization_types.depth_chart.name`,
    fallback: `Depth Chart`,
  },
  description: {
    translationKey: `explore_app:visualization_types.depth_chart.description`,
    fallback: `Plots measurements against depth. With each series manually allocated a depth. `,
  },
  hideVisualizationOptions: [
    'gauge',
    'indicator',
  ],
  canExportPNG: true,
  customOptions: {
    seriesType: 'line',
    echartsOptionsModifier: function(options, context) {
      options.xAxis.position = 'top';
      options.xAxis.type = 'value';
      options.xAxis.min = function (value) {
        const range = value.max - value.min;
        if (isNaN(range)) return;
        return round(value.min - (range * 0.1));
      };
      options.xAxis.max = function (value) {
        const range = value.max - value.min;
        if (isNaN(range)) return;
        return round(value.max + (range * 0.1));
      };
      options.xAxis.axisLine = {show: false};
      options.yAxis[0].inverse = true;
      options.dataZoom = [];
      // TODO: Edit the marker of each of the series so we can see the marker even if there is only one timeseries?
      options.tooltip = {
        show: true,
        trigger: 'axis',
        axisPointer: {
          type: 'cross',
          axis: 'y'
        },
        formatter: function(params, ticket, callback) {
          if (!params[0]) params = [params];
          let tooltip = '';
          const stationName = params[0].value[3];
          const sensorDefinitionName = params[0].value[4];
          tooltip += `${stationName} (${sensorDefinitionName})`;
          // TODO: include the depth
          params.forEach((series) => {
            const [reading, , time, , , precision, unit] = series.value;
            const timeStr = moment(time).format('YYYY-MM-DD HH:mm:ss');
            tooltip += `<br><span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${series.color};"></span>`;
            tooltip += `${series.seriesName}: ${round(reading, precision)} ${unit}  <em style="float: right; margin-left: 5px">(${timeStr})</em>`;
          });
          return tooltip;
        },
      };
      return;
    },
    echartsSeriesModifier: function(seriesConfig, context) {
      seriesConfig.showSymbol = true;
      return;
    },
  },
};

//////////////////////////////////////////////////////////////////
////////////////////////////// GAUGE /////////////////////////////
//////////////////////////////////////////////////////////////////
const gauge = {
  component: VisualizationEChart,
  componentName: 'visualization-e-chart',
  dataTransformer: function(dataArray) {
    return dataArray.map(dataItem => {

      let editedMeasurementArray = [];
      if (dataItem.data.length) {
        const latestReading = dataItem.data.slice(-1)[0][1];
        if (typeof latestReading !== 'string') {
          editedMeasurementArray = [{ value: latestReading }];
        }
      }

      return {
        ...dataItem,
        data: editedMeasurementArray,
      };
    });
  },
  id: `gauge`,
  carouselHTML: `<div style="padding: .5em; text-align: center; color: #151b1e;"><i class="fa fa-tachometer" style="font-size: 5.5em;"></i></div>`,
  name: {
    translationKey: `explore_app:visualization_types.gauge.name`,
    fallback: `Gauge`,
  },
  description: {
    translationKey: `explore_app:visualization_types.gauge.description`,
    fallback: `Display values on a single gauge. The min/max can be changed in visualization options.`,
  },
  hideVisualizationOptions: [
    'leftAxis',
    'rightAxis',
    'xAxis',
    'thresholdLines',
    'indicator',
  ],
  canExportPNG: true,
  customOptions: {
    seriesType: 'gauge',
    echartsOptionsModifier: function(options, context) {
      options.yAxis[0].show = false;
      options.yAxis[1].show = false;
      options.xAxis.show = false;
      options.grid.containLabel = false;
      options.tooltip = {
        formatter: function(params, ticket, callback) {
          const measurementDefinition = context.formattedData.find(e => e.id === params.seriesId).measurementDefinition;

          let unitText = '';
          if (measurementDefinition.unit_id) {
            const unit = context.uomUnits.find(e => e.unit_id === measurementDefinition.unit_id);

            if (unit) {
              unitText = unit.symbol;
            }
          }

          return `${params.seriesName}<br>${round(params.value, measurementDefinition.precision)} ${unitText}`;
        },
        position: options.tooltip.position,
        appendToBody: options.tooltip.appendToBody,
      };

      return;
    },
    echartsSeriesModifier: function(seriesConfig, context) {
      if (context.seriesCount !== 1) {
        seriesConfig.detail = { show: false };
      } else {
        seriesConfig.detail = {
          show: true,
          formatter: function(value) {
            const measurementDefinition = seriesConfig.measurementDefinition;

            let unitText = '';
            if (measurementDefinition.unit_id) {
              const unit = context.uomUnits.find(e => e.unit_id === measurementDefinition.unit_id);

              if (unit) {
                unitText = unit.symbol;
              }
            }

            return `${round(value, seriesConfig.measurementDefinition.precision)} ${unitText}`;
          },
        };
      }

      seriesConfig.min = Number(context.visualizationOptions.gauge.min) || 0;
      seriesConfig.max = Number(context.visualizationOptions.gauge.max) || 100;

      seriesConfig.radius = '98%';
      seriesConfig.center = [ '50%', '54%' ];
      if (context.visualizationOptions.display.title) {
        seriesConfig.radius = (parseFloat(seriesConfig.radius) - 8) + '%';
        seriesConfig.center[1] = (parseFloat(seriesConfig.center[1]) + 4) + '%';
      }
      if (context.visualizationOptions.display.subtitle) {
        seriesConfig.radius = (parseFloat(seriesConfig.radius) - 6) + '%';
        seriesConfig.center[1] = (parseFloat(seriesConfig.center[1]) + 4) + '%';
      }

      seriesConfig.splitLine = {
        distance: 0,
      };
      seriesConfig.axisTick = {
        distance: 0,
      };
      seriesConfig.axisLine = {
        lineStyle: {
          width: 5,
        },
      };
      seriesConfig.pointer = {
        length: '75%',
      };

      return;
    },
  },
};

//////////////////////////////////////////////////////////////////
///////////////////////////// TABLE //////////////////////////////
//////////////////////////////////////////////////////////////////
const table = {
  // component: VisualizationTable,
  componentName: 'visualization-table',
  dataTransformer: null,
  id: `table`,
  carouselHTML: `<div style="padding: .5em; text-align: center; color: #151b1e;"><i class="fa fa-table" style="font-size: 5.5em;"></i></div>`,
  name: {
    translationKey: `explore_app:visualization_types.table.name`,
    fallback: `Table`,
  },
  description: {
    translationKey: `explore_app:visualization_types.table.description`,
    fallback: `A tabular view of the data.`,
  },
  hideVisualizationOptions: [
    'display',
    'leftAxis',
    'rightAxis',
    'xAxis',
    'thresholdLines',
    'gauge',
    'indicator',
  ],
  canExportPNG: false,
  customOptions: {},
};

//////////////////////////////////////////////////////////////////
/////////////////////////// INDICATOR ////////////////////////////
//////////////////////////////////////////////////////////////////
const indicator = {
  // component: VisualizationIndicator,
  componentName: 'visualization-indicator',
  dataTransformer: function(dataArray) {
    return dataArray.map(dataItem => {

      let latestReading = null;
      if (dataItem.data.length) {
        latestReading = dataItem.data.slice(-1)[0][1];
      }

      return {
        ...dataItem,
        data: latestReading,
      };
    });
  },
  id: `indicator`,
  carouselHTML: `<div style="padding: .5em; text-align: center; color: #151b1e;"><i class="fa fa-circle" style="font-size: 5.5em;"></i></div>`,
  name: {
    translationKey: `explore_app:visualization_types.indicator.name`,
    fallback: `Indicator`,
  },
  description: {
    translationKey: `explore_app:visualization_types.indicator.description`,
    fallback: `Display a single colored circle based on the value of the measurement. The thresholds for each color can be set in the Visualization Options.`,
  },
  hideVisualizationOptions: [
    'display',
    'leftAxis',
    'rightAxis',
    'xAxis',
    'thresholdLines',
    'gauge',
  ],
  canExportPNG: false,
  customOptions: {},
};

//////////////////////////////////////////////////////////////////
/////////////////////////// WIND ROSE ///////////////////////////
//////////////////////////////////////////////////////////////////
const windRose = {
  // component: VisualizationWindRose,
  componentName: 'visualization-wind-rose',
  dataTransformer: function(dataArray) {
    const speedData = dataArray.find(e => e.measurementName.includes('speed')).data;
    const directionData = dataArray.find(e => e.measurementName.includes('direction')).data;
    
    return windRoseDataFormatter(speedData, directionData);
  },
  id: `wind_rose`,
  carouselHTML: `<div style="padding: .5em; text-align: center; color: #151b1e;"><i class="fa fa-bar-chart" style="font-size: 5.5em;"></i></div>`,
  name: {
    translationKey: `explore_app:visualization_types.wind_rose.name`,
    fallback: `Wind Rose`,
  },
  description: {
    translationKey: `explore_app:visualization_types.wind_rose.description`,
    fallback: `Displays wind data on a compass. Longer bars represent a larger percent of time that the wind was blowing that direction.`,
  },
  hideVisualizationOptions: [
    'gauge',
    'indicator',
  ],
  canExportPNG: true,
  customOptions: {
    seriesType: 'bar',
    echartsOptionsModifier: function(options, context) {
      options.polar = {};
      options.radiusAxis = {};
      return;
    },
    echartsSeriesModifier: function(seriesConfig, context) {
      seriesConfig.coordinateSystem = 'polar';
      return;
    },
  },
};

export default [
  lineChart,
  scatterChart,
  verticalBarChart,
  horizontalBarChart,
  // depthChart, // WIP
  gauge,
  // table, // Not needed
  // indicator,
  // windRose, // WIP
];